<template>
  <v-card class="bordered-card">
    <v-toolbar class="grey lighten-4 elevation-0">
      <v-toolbar-title class="grey--text text-underline text--darken-4">
        DoD Contract Analytics Page
      </v-toolbar-title>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs12>
        <block
            :items="items"
            :submitData="submitData"
            :loading="loading"
            type="dod-contract-analytics"
            :data="settings"
          />
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="3000"
      :success="updateProcess"
      :error="status === 'error'"
      v-model="updateProcess"
    >{{ process }}
    </v-snackbar>
  </v-card>
</template>

<script>
import Block from './sections/single_block.vue'

export default{
  components: {
    Block
  },
  props: ['settings'],
  computed: {
    styles () {
      return this.$store.getters.getStyles
    },
    loading () {
      return this.$store.getters.getLoading
    },
    error () {
      return this.$store.getters.getError
    },
    updateProcess () {
      return this.$store.getters.getProcess === 'Settings Saved'
    },
    process () {
      return this.$store.getters.getProcess
    }
  },
  data () {
    return {
      status: '',
      items: ['Edit DoD Contract Analytics Page Text']
    }
  },
  methods: {
    submitData (values) {
      this.$store.dispatch('savePageSettings', values)
    }
  }
}
</script>




// WEBPACK FOOTER //
// dod-contract-analytics.vue?4abed13c